<div class="container" >
    
    <div fxLayout="column"  fxLayout.gt-sm="row">
    <div fxFlex="67" class="border">

        <div class="padding-10">

            <div fxLayout="row" fxLayoutAlign="space-between center">

                <div *ngIf="name.length>0">
                    <calsoft-translator [translateValue]="name" [type]="'productsdetails'"></calsoft-translator>

                </div>

            </div>

            <div fxLayout="row" class="topclass" fxLayoutAlign="space-between center">

                <p class="detailcss" [innerHTML]="description"></p>
            </div>


            <div fxLayout="row" class="topclass" fxLayoutAlign="space-between center">

                <calsoft-product-details fxFlex="100" [spec]="spec" [title]="'Catalog Specification'">

                </calsoft-product-details>

            </div>

            <div fxLayout="row" class="topclass" fxLayoutAlign="space-between center">

                <calsoft-review-rating [reviewDetail]="reviewDetail"></calsoft-review-rating>

            </div>

        </div>

    </div>

    <div fxFlex="3">

    </div>

    <div fxFlex="30" class="border">

        <div class="padding-10">

            <div *ngIf="data.disablePriceInDetailPage==0">

                <div fxLayoutAlign="space-between center">

                    <div>
                        <b style="font-size: 18px;">Price : </b> <b>{{price |currencyConvert }}</b>
                    </div>

                    <div class="primary padding-3" style="color: white;">
                        <span>In Stock</span>
                    </div>

                </div>

            </div>

            <!-- <div fxLayout="row" class="topclass" fxLayoutAlign="space-between center">

             <span> Estimated Delivery : ( Working Days ) </span>   

            </div> -->


            <div fxLayout="row" class="topclass" fxLayoutAlign="space-between center">

                <div fxFlex="100" *ngIf="data.disableCartInDetailPage==0 &&product.type!='Subscription'">
                    <div *ngIf="isInStock==1 ">

                        <calsoft-controls [data]="data"
                        [coversionTrackingIdGa]="coversionTrackingIdGa"
                            *ngIf="(qty>0 && isInStock==1)||(manageStock==0); else elseBlock" fxHide.xs fxShow.lt-lg
                            [productCustomOption]="productCustomOption" [productOption]="salesFlatQuoteItemOption"
                            [product]="configProductSelected" [configproduct]="product" [type]="'addtocart'"
                            [buttonArray]="buttonArray" [configproduct]="product">
                        </calsoft-controls>
                    </div>

                </div>

            </div>

            <div fxLayout="row" class="topclass" fxLayoutAlign="space-between center">
                <b>
                    Share Catalog :
                </b>

            </div>

            <div fxLayout="row" class="topclass" fxLayoutAlign="center center">
                <div *ngIf="fileName!=undefined" fxFlex="100">
                    <button (click)="downloadPdf()" fxFlex="100" style="color: black; border: 1px solid lightgray;" mat-button>Download Catalog
                    </button>
                </div>

                <div class="padding-3">
    
                </div>

                <div fxFlex="100">
                    <button fxFlex="100" (click)="generateWhatsAppMessage()" style="color: black; border: 1px solid lightgray;" mat-button>Click To Inquiry
                    </button>
                </div>
            </div>

        </div>





    </div>

    </div>


    <div fxLayout="row" class="topclass" fxLayoutAlign="space-between center">
        <div *ngIf="imageList.length == '1'">
            <div fxLayout="row" fxLayout.xs="column" *ngFor="let image of imageList; let i=index">
                <div fxFlex="100" style="padding: 10px;" fxFlex.xs="100">
                    <div *ngIf="image=='sassa'">
                        <img [alt]="name" class="imgH" src="src/assets/images/products/noImage/no-image.png">
                    </div>
    
                    <div *ngIf="image!='sassa'">
                        <div
                            *ngIf="!image.includes('medicineimages')&&!image.includes('http')&&!image.includes('commonimages')">
                            <img [src]="bigImage+image | safe: 'resourceUrl'"
                                onerror="this.src='assets/images/products/noImage/no-image.png';" class="primarycss1" />
                        </div>
    
                        <div *ngIf="image.includes('http')">
                            <img [src]="image | safe: 'resourceUrl'"
                                onerror="this.src='assets/images/products/noImage/no-image.png';" class="primarycss1" />
                        </div>
    
                        <div *ngIf="image.includes('medicineimages')">
                            <img [src]="commonImageApi+image| safe: 'resourceUrl'"
                                onerror="this.src='assets/images/products/noImage/no-image.png';" class="primarycss1" />
                        </div>
    
                        <div *ngIf="image.includes('commonimages')">
                            <img [src]="serverPath7+image| safe: 'resourceUrl'"
                                onerror="this.src='assets/images/products/noImage/no-image.png';" class="primarycss1" />
                        </div>
    
                    </div>
                </div>
            </div>
        </div>
    
        <div *ngIf="imageList.length == 2">
            <div fxLayout="row" fxLayout.xs="column" *ngIf="isImageValid()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="bigImage+imageList[0]"  class="primarycss" />
                </div>
                <div fxFlex="50">
                    <div class="secondaryimage">
                        <div style="margin: 10px;">
                            <img [src]="bigImage+imageList[1]" style="width: 100%;height: 100%;" class="primary_css" />
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" *ngIf="idHttp()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="imageList[0]"  class="primarycss" />
                </div>
                <div fxFlex="50">
                    <div class="secondaryimage">
                        <div style="margin: 10px;">
                            <img [src]="imageList[1]" style="width: 100%;height: 100%;" class="primary_css" />
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" *ngIf="medicineImg()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="commonImageApi+imageList[0]"  class="primarycss" />
                </div>
                <div fxFlex="50">
                    <div class="secondaryimage">
                        <div style="margin: 10px;">
                            <img [src]="commonImageApi+imageList[1]" style="width: 100%;height: 100%;"
                                class="primary_css" />
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" *ngIf="containsCommonImages()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="serverPath7+imageList[0]"  class="primarycss" />
                </div>
                <div fxFlex="50">
                    <div class="secondaryimage">
                        <div style="margin: 10px;">
                            <img [src]="serverPath7+imageList[1]" style="width: 100%;height: 100%;" class="primary_css" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div *ngIf="imageList.length == 3">
            <div fxLayout="row" fxLayout.xs="column" *ngIf="isImageValid()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="bigImage+imageList[0]" style="width: 100%;height: 100%;" />
                </div>
                <div fxFlex="50" fxLayout="column">
                    <div class="secondaryimage">
                        <div style="margin: 10px;">
                            <img [src]="bigImage+imageList[1]"
                                style="width: 100%;height: 100%;border-top-right-radius: 20px;" />
                        </div>
                        <div style="margin: 10px;">
                            <img [src]="bigImage+imageList[2]"
                                style="width: 100%;height: 100%;border-bottom-right-radius: 20px;" />
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" *ngIf="idHttp()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="imageList[0]" style="width: 100%;height: 100%;" />
                </div>
                <div fxFlex="50" fxLayout="column">
                    <div class="secondaryimage">
                        <div style="margin: 10px;">
                            <img [src]="imageList[1]" style="width: 100%;height: 100%;border-top-right-radius: 20px;" />
                        </div>
                        <div style="margin: 10px;">
                            <img [src]="imageList[2]" style="width: 100%;height: 100%;border-bottom-right-radius: 20px;" />
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" *ngIf="medicineImg()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="commonImageApi+imageList[0]"  class="primarycss" />
                </div>
                <div fxFlex="50" fxLayout="column">
                    <div class="secondaryimage">
                        <div style="margin: 10px;">
                            <img [src]="commonImageApi+imageList[1]"
                                style="width: 100%;height: 100%;border-top-right-radius: 20px;" />
                        </div>
                        <div style="margin: 10px;">
                            <img [src]="commonImageApi+imageList[2]"
                                style="width: 100%;height: 100%;border-bottom-right-radius: 20px;" />
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" *ngIf="containsCommonImages()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="serverPath7+imageList[0]"  class="primarycss" />
                </div>
                <div fxFlex="50" fxLayout="column">
                    <div class="secondaryimage">
                        <div style="margin: 10px;">
                            <img [src]="serverPath7+imageList[0]"
                                style="width: 100%;height: 100%;border-top-right-radius: 20px;" />
                        </div>
                        <div style="margin: 10px;">
                            <img [src]="serverPath7+imageList[0]"
                                style="width: 100%;height: 100%;border-bottom-right-radius: 20px;" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div *ngIf="imageList.length == 4">
    
            <div fxLayout="row" fxLayout.xs="column" *ngIf="isImageValid()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="bigImage+imageList[0]"  class="primarycss" />
                </div>
                <div fxFlex="50">
                    <div class="secondaryimage">
                        <div fxLayout="row">
                            <div fxFlex="100" style="margin: 10px;">
                                <img [src]="bigImage+imageList[1]" style="width: 100%;" />
                            </div>
                        </div>
                        <div fxLayout="row">
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="bigImage+imageList[2]" style="width: 100%;border-top-right-radius: 20px;" />
                            </div>
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="bigImage+imageList[3]" style="width: 100%;border-bottom-right-radius: 20px;" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" *ngIf="idHttp()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="imageList[0]"  class="primarycss" />
                </div>
                <div fxFlex="50">
                    <div class="secondaryimage">
                        <div fxLayout="row">
                            <div fxFlex="100" style="margin: 10px;">
                                <img [src]="imageList[1]" style="width: 100%;border-top-right-radius: 20px;" />
                            </div>
                        </div>
                        <div fxLayout="row">
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="imageList[2]" style="width: 100%;" />
                            </div>
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="imageList[3]" style="width: 100%;border-bottom-right-radius: 20px;" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" *ngIf="medicineImg()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="commonImageApi+imageList[0]"  class="primarycss" />
                </div>
                <div fxFlex="50">
                    <div class="secondaryimage">
                        <div fxLayout="row">
                            <div fxFlex="100" style="margin: 10px;">
                                <img [src]="commonImageApi+imageList[1]"
                                    style="width: 100%;border-top-right-radius: 20px;" />
                            </div>
                        </div>
                        <div fxLayout="row">
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="commonImageApi+imageList[2]" style="width: 100%;" />
                            </div>
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="commonImageApi+imageList[3]"
                                    style="width: 100%;border-bottom-right-radius: 20px;" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" *ngIf="containsCommonImages()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="serverPath7+imageList[0]"  class="primarycss" />
                </div>
                <div fxFlex="50">
                    <div class="secondaryimage">
                        <div fxLayout="row">
                            <div fxFlex="100" style="margin: 10px;">
                                <img [src]="serverPath7+imageList[1]" style="width: 100%;border-top-right-radius: 20px;" />
                            </div>
                        </div>
                        <div fxLayout="row">
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="serverPath7+imageList[2]" style="width: 100%;" />
                            </div>
                            <div fxFlex="50" style="margin: 10px;">
                                <img [src]="serverPath7+imageList[3]"
                                    style="width: 100%;border-bottom-right-radius: 20px;" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        </div>
    
    
        <div *ngIf="imageList.length == 5">
    
            <div fxLayout="row" fxLayout.xs="column" *ngIf="isImageValid()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="bigImage+imageList[0]" class="primarycss" />
                </div>
                <div fxFlex="50" class="secondary-image">
                    <div fxLayout="row">
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="bigImage+imageList[1]" style="width: 100%;height: 100%;" />
                        </div>
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="bigImage+imageList[2]"
                                style="width: 100%;border-top-right-radius: 20px;height: 100%;" />
                        </div>
                    </div>
                    <div fxLayout="row">
                        <div fxFlex="50" style="margin: 10px;">
                            <div fxLayout="row">
                                <div fxFlex="50" style="margin: 10px;">
                                    <img [src]="bigImage+imageList[3]" style="width: 100%;height: 100%;" />
                                </div>
                                <div fxFlex="50" style="margin: 10px;">
                                    <img [src]="bigImage+imageList[4]"
                                        style="width: 100%;border-bottom-right-radius: 20px;height: 100%;" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" *ngIf="idHttp()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="imageList[0]" class="primarycss" />
                </div>
                <div fxFlex="50" class="secondary-image">
                    <div fxLayout="row">
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="imageList[1]" style="width: 100%;height: 100%" />
                        </div>
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="imageList[2]" style="width: 100%;border-top-right-radius: 20px;height: 100%" />
                        </div>
                    </div>
                    <div fxLayout="row">
                        <div fxFlex="50" style="margin: 10px;">
                            <div fxLayout="row">
                                <div fxFlex="50" style="margin: 10px;">
                                    <img [src]="imageList[3]" style="width: 100%;height: 100%" />
                                </div>
                                <div fxFlex="50" style="margin: 10px;">
                                    <img [src]="imageList[4]"
                                        style="width: 100%;border-bottom-right-radius: 20px;height: 100%" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" *ngIf="medicineImg()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="commonImageApi+imageList[0]" class="primarycss" />
                </div>
                <div fxFlex="50" class="secondary-image">
                    <div fxLayout="row">
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="commonImageApi+imageList[1]" style="width: 100%;height: 100%" />
                        </div>
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="commonImageApi+imageList[2]"
                                style="width: 100%;border-top-right-radius: 20px;height: 100%" />
                        </div>
                    </div>
                    <div fxLayout="row">
                        <div fxFlex="50" style="margin: 10px;">
                            <div fxLayout="row">
                                <div fxFlex="50" style="margin: 10px;">
                                    <img [src]="commonImageApi+imageList[3]" style="width: 100%;height: 100%" />
                                </div>
                                <div fxFlex="50" style="margin: 10px;">
                                    <img [src]="commonImageApi+imageList[4]"
                                        style="width: 100%;border-bottom-right-radius: 20px;height: 100%" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div fxLayout="row" fxLayout.xs="column" *ngIf="containsCommonImages()">
                <div fxFlex="50" style="padding: 10px;" fxFlex.xs="100">
                    <img [src]="serverPath7+imageList[0]" class="primarycss" />
                </div>
                <div fxFlex="50" class="secondary-image">
                    <div fxLayout="row">
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="serverPath7+imageList[1]" style="width: 100%;height: 100%" />
                        </div>
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="serverPath7+imageList[2]"
                                style="width: 100%;border-top-right-radius: 20px;height: 100%" />
                        </div>
                    </div>
                    <div fxLayout="row">
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="serverPath7+imageList[3]" style="width: 100%;height: 100%" />
                        </div>
                        <div fxFlex="50" style="margin: 10px;">
                            <img [src]="serverPath7+imageList[4]"
                                style="width: 100%;border-bottom-right-radius: 20px;height: 100%" />
                        </div>
                    </div>
    
                </div>
            </div>
    
        </div>
    </div>

    <div  style="width: 100%"  *ngIf="fileNameExist" fxLayout="row" class="topclass" fxLayoutAlign="space-between center">
        <calsoft-pdf-viewer  style="width: 100%"  [fileName]="fileName"></calsoft-pdf-viewer>
    </div>

</div>